import _regeneratorRuntime from "@babel/runtime/regenerator";
import { call, take, cancelled } from 'redux-saga/effects';
import { viewModelStateUpdate } from './actions';

var eventListenerSaga = /*#__PURE__*/_regeneratorRuntime.mark(function eventListenerSaga(_ref, _ref2) {
  var viewModels, sagaKey, sagaManager, client, store, cursor, url, query, state, viewModel, name, aggregateIds, args, projection, viewModelState, subscription;
  return _regeneratorRuntime.wrap(function eventListenerSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          viewModels = _ref.viewModels, sagaKey = _ref.sagaKey, sagaManager = _ref.sagaManager, client = _ref.client, store = _ref.store;
          cursor = _ref2.cursor, url = _ref2.url, query = _ref2.query, state = _ref2.state, viewModel = _ref2.viewModel;
          name = query.name, aggregateIds = query.aggregateIds, args = query.args;
          projection = viewModel.projection;
          viewModelState = state;
          _context.next = 7;
          return call([client, client.subscribe], url, cursor, name, aggregateIds, function (event) {
            viewModelState = projection[event.type](viewModelState, event, args);
            store.dispatch(viewModelStateUpdate(query, viewModelState, false));
          });

        case 7:
          subscription = _context.sent;
          _context.prev = 8;
          _context.next = 11;
          return take(function () {
            return false;
          });

        case 11:
          _context.prev = 11;
          _context.next = 14;
          return cancelled();

        case 14:
          if (!_context.sent) {
            _context.next = 17;
            break;
          }

          _context.next = 17;
          return call([client, client.unsubscribe], subscription);

        case 17:
          return _context.finish(11);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, eventListenerSaga, null, [[8,, 11, 18]]);
});

export default eventListenerSaga;
//# sourceMappingURL=event-listener-saga.js.map